import * as s from "./ConceptsManager.module.css";

export const conceptsManagerStyles = s;
